import { jsx as _jsx } from "react/jsx-runtime";
import { EMPTY_OBJ } from '../utils';
import { DialectContextProvider } from './DialectContext';
import { DialectWalletStatesHolder } from './DialectContext/Wallet';
export { DialectContextProvider } from './DialectContext';
export { DialectWalletStatesHolder } from './DialectContext/Wallet';
export const DialectNoBlockchainSdk = (props) => {
    return (_jsx(DialectWalletStatesHolder.Provider, { children: _jsx(DialectContextProvider, { config: EMPTY_OBJ, blockchainSdkFactory: null, children: props.children }) }));
};
//# sourceMappingURL=index.js.map